import { all, put, takeEvery } from 'redux-saga/effects';
import gql from 'graphql-tag';
import {PORTAL_ACCOUNT_UPDATE} from '../components/Pages/Account/graphql'
import { client } from 'src/apollo';
import { history } from '../store';


function* handleUpdateAccount(action) {
    try {
        const variables = {"data": {
            "email": action.payload['email'],
            "phone": action.payload['phone'],
            "name": action.payload['name']
        }};
        const { data } = yield client.mutate({
            mutation: PORTAL_ACCOUNT_UPDATE,
            variables: variables
        });
        history.go('/conta');
    } catch(error) {
        alert("erro" + error.message);
    }
  
}

function* watchUpdateAccountSubmit() {
    yield takeEvery('UPDATE_ACCOUNT_SUBMIT', handleUpdateAccount);
}

export default function* root() {
    yield all([
        watchUpdateAccountSubmit()
    ]);
}





// WEBPACK FOOTER //
// ./src/sagas/account.js